var _path, _rect, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m304 328h24v32h-24z",
    fill: "#f5cbaa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#e74444",
    height: 336,
    rx: 16,
    width: 208,
    x: 120,
    y: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m232 24h48v336h-48z",
    fill: "#6a7073"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m168 56h32v152h-32z",
    fill: "#d9dbdd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m392 311.059v176.941h-56a80 80 0 0 1 -80-80h.16l-51.9-76.805a32 32 0 0 1 8.6-44.43 32 32 0 0 1 44.43 8.6l46.71 64.635h24v-192l60.235 128a32 32 0 0 1 3.765 15.059z",
    fill: "#f5cbaa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136 368h83.478l28.55 42.254a88.1 88.1 0 0 0 87.972 85.746h56a8 8 0 0 0 8-8v-176.941a40.148 40.148 0 0 0 -4.606-18.637l-59.394-126.21v-126.212a24.028 24.028 0 0 0 -24-24h-176a24.028 24.028 0 0 0 -24 24v304a24.028 24.028 0 0 0 24 24zm245.177-68.235a24.1 24.1 0 0 1 2.823 11.294v168.941h-48a72.085 72.085 0 0 1 -71.984-70.485 8 8 0 0 0 -1.227-5.994l-51.889-76.805a24 24 0 1 1 39.771-26.872c.047.069.1.138.145.206l46.705 64.636a8 8 0 0 0 6.479 3.314h24a8 8 0 0 0 8-8v-156.212l45 95.618c.054.121.113.24.177.359zm-117.327-8.989a39.85 39.85 0 0 0 -23.85-16.4v-242.376h32v270.056zm56.15-250.776v312h-11.911l-20.089-27.8v-292.2h24a8.009 8.009 0 0 1 8 8zm-192 0a8.009 8.009 0 0 1 8-8h88v241.872a39.988 39.988 0 0 0 -26.363 61.8l11.031 16.328h-72.668a8.009 8.009 0 0 1 -8-8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m168 216h32a8 8 0 0 0 8-8v-152a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v152a8 8 0 0 0 8 8zm8-152h16v136h-16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e09c0039dbd2ceeb366aad52714400e1.svg";
export { ForwardRef as ReactComponent };